export const edit_profile_popup_events = {
  home_edit_profile_click: {
    category: "User opens edit popup",
    action: "User clicks on edit icon",
    label: "sidebar-profile-edit-click",
  },
  home_submit_edit_profile_click: {
    category: "User updates the profile",
    action: "User clicks on edit profile popup save changes button",
    label: "profile-modal-save-click",
  },
  home_delete_account_click: {
    category: "User opens delete account popup",
    action: "User clicks delete account button in edit profile popup",
    label: "profile-modal-delete-account-click",
  },
  Profile_yes_delete_account_click: {
    category: "User deletes account",
    action: "User clicks on Yes delete account button",
    label: "profile-modal-yes-delete-account-click",
  },
  Profile_delete_cancel_click: {
    category: "User cancels account deletion",
    action: "User clicks on cancel button from delete account ",
    label: "profile-modal-delete-cancel-click",
  },
  edit_profile_mobile_phone_input_field: {
    category: "Edit profile interaction",
    action: "User interacts with mobile phone input field",
    label: "profile-modal-phone-input",
  },
  edit_profile_name_input_field: {
    category: "Edit profile interaction",
    action: "User interacts with name input field",
    label: "profile-modal-name-input",
  },
  edit_profile_close_modal: {
    category: "Edit profile interaction",
    action: "User clicks on close button in edit profile modal",
    label: "profile-modal-close-click",
  },
  edit_profile_your_name_click: {
    category: "Edit profile interaction",
    action: "User clicks on Your Name field",
    label: "edit-profile-your-name-click",
  },
};
